import { FC } from 'react';
import * as React from 'react';

import { CustomNextImage as Image } from '@crehana/next';
import { Dialog, DialogContent } from '@crehana/ui';

import useHeaderTranslation from '../../hooks/useHeaderTranslation';
import data from './ContactDialog.data';

interface ContactDialogProps {
  open: boolean;
  onDismiss: () => void;
}

const ContactDialog: FC<React.PropsWithChildren<ContactDialogProps>> = ({
  open,
  onDismiss,
}) => {
  const { t } = useHeaderTranslation();

  return (
    <Dialog open={open} onDismiss={onDismiss}>
      <DialogContent type="s">
        <h4 className="font-h4 text-center mb-16 whitespace-pre-line">
          {t('HEADER_CONTACT_DIALOG_TITLE')}
        </h4>
        <p className="font-body3 text-gray-dark mb-24 text-center whitespace-pre-line">
          {t('HEADER_CONTACT_DIALOG_DESCRIPTION')}
        </p>
        <div className="flex flex-col items-center justify-center">
          {data.phones.map(phone => (
            <p
              key={phone.id}
              className="flex items-center font-subtitle2 mb-16"
            >
              <Image
                src={phone.flag}
                width={24}
                height={16}
                quality={80}
                alt="pe"
              />
              <a className="text-base-main ml-8" href={`tel:${phone.number}`}>
                {`(${phone.iso}) ${phone.number}`}
              </a>
            </p>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ContactDialog;
